module.exports = __webpack_public_path__ + "img/eg-sons-sales-inc.8f962cee.png";